export default function filtersApiAdapter(filters) {
  return {
    builder: filters.builders,
    epoch: filters.epochs,
    region: filters.regions,
    street: filters.streets,
    type: filters.types,
    focus: filters.focus
  }
}